var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"id":"mainContainer","align-v":"center"}},[_c('b-row',{attrs:{"align-v":"center","align-h":"center"}},[_c('FormLogin')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/views/LoginPage.vue